import { render, staticRenderFns } from "./sjblRight.vue?vue&type=template&id=e99765c8&scoped=true&"
import script from "./sjblRight.vue?vue&type=script&lang=js&"
export * from "./sjblRight.vue?vue&type=script&lang=js&"
import style0 from "./sjblRight.vue?vue&type=style&index=0&id=e99765c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99765c8",
  null
  
)

export default component.exports